import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {extendForms} = api

/**
 * 查找
 */
export async function findExtendForms(params) {
    return request({url: extendForms, method: 'get', data: params,})
}





// WEBPACK FOOTER //
// ./src/services/qaForm.js